import React, { FC, InputHTMLAttributes } from 'react';
import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import '../form.scss';

interface InputTimezoneProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  Controller: any;
  control?: any;
  label?: string;
  methods?: any;
  wrapperClass?: string;
  className?: string;
  error?: any;
  register?: any;
  placeholder?: string;
}

const Input: FC<InputTimezoneProps> = ({
  methods,
  Controller,
  control,
  name,
  label,
  wrapperClass,
  error,
  placeholder,
  ...rest
}) => {
  return (
    <div className={`${wrapperClass} flex flex-col items-start pb-4 text-sm`}>
      {label && (
        <label className="text-neutral7 uppercase" htmlFor={name}>
          {label}
        </label>
      )}

      <Controller
        control={control}
        name={name}
        {...rest}
        render={({ field: { onChange, value } }: any) => {
          return (
            <TimezoneSelect
              value={value ? value : Intl.DateTimeFormat().resolvedOptions().timeZone}
              onChange={onChange}
              className="select-wrapper w-full"
              labelStyle="altName"
              placeholder={placeholder}
              displayValue="UTC"
              timezones={{
                ...allTimezones,
                'America/New_York': 'New York',
                'America/Chicago': 'Chicago',
                'America/Denver': 'Denver',
                'America/Los_Angeles': 'Los Angeles',
                'America/Phoenix': 'Phoenix',
                'America/Anchorage': 'Anchorage',
                'America/Adak': 'Adak',
                'America/Halifax': 'Halifax',
                'America/Edmonton': 'Edmonton',
                'America/Toronto': 'Toronto',
                'America/Montreal': 'Montreal',
                'America/Vancouver': 'Vancouver',
                'America/Winnipeg': 'Winnipeg',
                'America/Regina': 'Regina',
                'America/Whitehorse': 'Whitehorse',
                'America/Boise': 'Boise',
                'America/Juneau': 'Juneau',
                'America/Mexico_City': 'Mexico City',
                'America/Puerto_Rico': 'Puerto Rico',
                'America/Indianapolis': 'Indianapolis',
                'America/Detroit': 'Detroit',
                'America/Minneapolis': 'Minneapolis',
                'America/Atlanta': 'Atlanta',
                'America/Dallas': 'Dallas',
                'America/Lima': 'Lima',
                'America/Santiago': 'Santiago',
                'America/Bogota': 'Bogota',
                'America/Godthab': 'Godthab',
                'America/Buenos_Aires': 'Buenos Aires',
                'America/Montevideo': 'Montevideo',
                'America/Caracas': 'Caracas',
                'America/Manaus': 'Manaus',
                'America/La_Paz': 'La Paz',
                'America/Asuncion': 'Asuncion',
                'America/Sao_Paulo': 'Sao Paulo',
                'America/Cuiaba': 'Cuiaba',
                'America/Amazon': 'Amazon',
                'America/Belem': 'Belem',
                'America/Fortaleza': 'Fortaleza',
                'America/Recife': 'Recife',
                'America/Noronha': 'Noronha',
                'America/Maceio': 'Maceio',
                'America/Bahia': 'Bahia',
                'America/Santarem': 'Santarem',
                'America/Porto_Velho': 'Porto Velho',
                'America/Boa_Vista': 'Boa Vista',
                'America/Eirunepe': 'Eirunepe',
                'America/Rio_Branco': 'Rio_Branco',
                'America/Honolulu': 'Honolulu',
                'Pacific/Midway': 'Midway',
                'Pacific/Pago_Pago': 'Pago Pago',
                'America/Tijuana': 'Tijuana',
                'America/Hermosillo': 'Hermosillo',
                'America/Chihuahua': 'Chihuahua',
                'America/Mazatlan': 'Mazatlan',
                'America/Dawson_Creek': 'Dawson Creek',
                'America/Louisville': 'Louisville',
                'America/Monticello': 'Monticello',
                'America/Sitka': 'Sitka',
                'America/Yakutat': 'Yakutat',
                'America/Nome': 'Nome',
                'Pacific/Honolulu': 'Honolulu',
                'America/Pago_Pago': 'Pago Pago',
                'America/Midway': 'Midway'
              }}
            />
          );
        }}
      />

      {error && (
        <span className="error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default Input;
